<template>
<v-app>
  <div>
    <v-btn color="info" v-on:click="gotoUsers">Usuarios</v-btn>
    <v-btn color="info" v-on:click="gotoNews">Noticias</v-btn>
    <v-btn color="info" v-on:click="gotoComments">Sugerencias</v-btn>
    <v-btn color="info" v-on:click="gotoShops">Locales</v-btn>
    <v-btn color="error" v-on:click="logout">Salir</v-btn>
    <img src="../assets/logo.png" width="100px" style="float: right;">
    <hr style="margin-bottom: 50px;">

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form>
                <div>
                    <div class="title" style="margin-bottom: 10px;">Datos del Usuario</div>
                    <b>Nombre:</b> {{ name }}<br />
                    <b>Email:</b> {{ email }}<br />
                    <b>Registro:</b> {{ createdAtStr }} ({{ origin }})<br />
                    <b>Último Ingreso:</b> {{ lastLoginAtStr }}<br />
                    <b>Ingresos:</b> {{ logins }}<br />
                </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="clearForm()" style="margin-top: 15px;">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="display-2" style="margin-bottom: 10px;">
        Usuarios

        <v-btn
            fab
            color="primary"
            right
            absolute
            @click="exportUsers()"
            >
            <v-icon>save</v-icon>
        </v-btn>
    </div>

    <a v-bind:href="exportDownloadURL" v-if="(exportDownloadURL != '')">Descargar Reporte Generado ({{ exportFilename }})</a>

    <table width="100%" ref="tableContainer" style="margin-top: 50px;">
        <thead class="title">
            <th style="text-align: left;">Nombre</th>
            <th style="text-align: left;">Email</th>
            <th style="text-align: left;">Registro</th>
            <th style="text-align: right;">Ingresos</th>
            <th style="text-align: right;">Acciones</th>
        </thead>
        <tr v-for="(user, idx) in users" :key="idx">
            <td style="text-align: left;">{{ user.name }}</td>
            <td style="text-align: left;">{{ user.email }}</td>
            <td style="text-align: left;">{{ user.createdAtStr }} ({{ user.origin }})</td>
            <td style="text-align: right;">{{ user.logins }}</td>
            <td style="text-align: right;">
                <v-btn fab small color="primary" @click="startItemEdit(user.id)">
                    <v-icon>search</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td style="text-align: left;"></td>
            <td style="text-align: left;"></td>
            <td style="text-align: right;" colspan="3">
                <v-btn color="success" @click="getUsers()">
                    Cargar mas items
                    <v-icon right>cloud_download</v-icon>
                </v-btn>
            </td>
        </tr>
    </table>
  </div>
</v-app>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import firebase from 'firebase'
import { db } from '../main'
export default {
    name: 'Users',
    data () {
        return {
            dialog: false,
            users: [],
            isEdition: false,
            itemID: '',
            name: '',
            email: '',
            createdAtStr: '',
            lastLoginAtStr: '',
            origin: '',
            logins: '',
            exportDownloadURL: '',
            exportFilename: '',
            lastListDoc: null,
            loaderPrefs: {
                'container': null,
                'canCancel': false,
                'color': '#0000FF',
                'background-color': '#FFCC99',
            },
        }
    },
    methods: {
        getUsers (auto) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;
            var query;

            if (vm.lastListDoc) {
                console.log("lastListDoc", vm.lastListDoc);
                query = db.collection("users")
                    .orderBy("createdAt", "desc")
                    .startAfter(vm.lastListDoc)
                    .limit(10);
            } else {
                console.log("No lastListDoc");
                query = db.collection("users")
                    .orderBy("createdAt", "desc")
                    .limit(10);
            }

            query.get()
                .then(function(res) {
                    console.log("Received: " + res.docs.length);

                    res.forEach(doc => {
                        let item = doc.data();
                        item.id = doc.id;
                        item.createdAtStr = vm.formatDate(item.createdAt.toDate());
                        item.lastLoginAtStr = (item.lastLoginAt) ? vm.formatDate(item.lastLoginAt.toDate()) : '';
                        vm.users.push(item);

                        vm.lastListDoc = doc;
                    });

                    if (res.docs.length == 0 && auto !== true) {
                        alert("No hay más usuarios!");
                    }

                    loader.hide();
            })
            .catch(function(error) {
                console.error("Error getting users list: ", error);
                loader.hide();
            });
        },
        exportUsers () {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;
            var query = db.collection("users").orderBy("createdAt", "desc");

            var exportedData = '';
            var exportedRows = ['"ID";"NOMBRE";"EMAIL";"REGISTRO";"ORIGEN";"INGRESOS";"ULTIMOINGRESO"'];
            query.get()
                .then(function(res) {
                    console.log("Received: " + res.docs.length);

                    res.forEach(doc => {
                        let item = doc.data();
                        item.id = doc.id;
                        item.createdAtStr = vm.formatDate(item.createdAt.toDate());
                        item.lastLoginAtStr = (item.lastLoginAt) ? vm.formatDate(item.lastLoginAt.toDate()) : '';

                        let s = '"'+item.id+'";';
                        s += '"'+item.name+'";';
                        s += '"'+item.email+'";';
                        s += '"'+item.createdAtStr+'";';
                        s += '"'+item.origin+'";';
                        s += item.logins+';'
                        s += '"'+item.lastLoginAtStr+'"';

                        exportedRows.push(s);
                    });

                    exportedData = exportedRows.join('\n');

                    var reportName = "USUARIOS_" + vm.formatDate(new Date(), 'YYYYMMDDHHMI', '', '_', '');
                    console.log("Data Name: " + reportName);
                    console.log("Data Size: " + exportedData.length);

                    // Create a root reference
                    var storageRef = firebase.storage().ref();
                    var reportRef = storageRef.child('reports/' + reportName + '.csv');
                    var metadata = {
                      contentType: 'text/csv',
                    };

                    reportRef.putString(exportedData, 'raw', metadata)
                      .then(function(snapshot) {
                        console.log('Uploaded a raw string!');
                        console.log(snapshot);

                        reportRef.getDownloadURL().then(function(url) {
                          console.log('Report URL: ' + url);

                          vm.exportDownloadURL = url;
                          vm.exportFilename = reportName + '.csv';

                          alert("Se ha generado el reporte de usuarios!");
                          loader.hide();
                        });

                      })
                      .catch(function(error) {
                          console.error("Error uploading report: ", error);
                          loader.hide();
                      });
                })
                .catch(function(error) {
                    console.error("Error getting users list: ", error);
                    loader.hide();
                });
            
        },
        startItemEdit (id) {
            var vm = this;

            var idx = -1;
            for (var i=0; i<vm.users.length; i++) {
                if (id == vm.users[i].id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                this.isEdition = true;
                this.itemID = vm.users[idx].id;
                this.name = vm.users[idx].name;
                this.email = vm.users[idx].email;
                this.createdAtStr = vm.formatDate(vm.users[idx].createdAt.toDate());
                this.lastLoginAtStr = (vm.users[idx].lastLoginAt) ? vm.formatDate(vm.users[idx].lastLoginAt.toDate()) : 'N/D';
                this.origin = vm.users[idx].origin;
                this.logins = vm.users[idx].logins;
            }

            this.dialog = true;
        },
        clearForm () {
            this.dialog = false;

            // Clear values
            this.isEdition = false
            this.itemID = ''
            this.name = ''
            this.email = ''
            this.createdAtStr = ''
            this.lastLoginAtStr = ''
            this.origin = ''
            this.logins = ''
        },
        gotoUsers () {
            this.$router.replace('users');
        },
        gotoNews () {
            this.$router.replace('news');
        },
        gotoComments () {
            this.$router.replace('comments');
        },
        gotoShops () {
            this.$router.replace('shops');
        },
        logout () {
            firebase.auth().signOut().then(() => {
                this.$router.replace('login')
            })
        },
        formatDate(d, format, fsep, msep, hsep) {
            if (!d) return "";

            if (!format) format = 'DD/MM/YYYY HH:MM'; 
            if (fsep === undefined) fsep = '/'; 
            if (msep === undefined) msep = ' '; 
            if (hsep === undefined) hsep = ':'; 

            let m = (d.getMonth() + 1);
            if (m < 10) {
                m = "0" + m;
            }

            let mi = d.getMinutes();
            if (mi < 10) {
                mi = "0" + mi;
            }

            if (format == 'YYYYMMDDHHMI') {
                return d.getFullYear() + fsep + m + fsep + d.getDate() + msep + d.getHours() + hsep + mi;
            } else {
                return d.getDate() + fsep + m + fsep + d.getFullYear() + msep + d.getHours() + hsep + mi;
            }
        }
    },
    mounted: function () {
        var vm = this;
        this.$nextTick(function () {
            vm.getUsers(true);
        })
    }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: black;
}
input, button {
  margin-bottom: 10px;
}
.button_blue {
  background-color: rgb(158, 206, 255);
}
.button_red {
  background-color: rgb(255, 154, 154);
}
.logout {
  left: 50%;
  top: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Users.vue